module.exports = __webpack_public_path__ + "img/sarl-dvb.fdb184e4.png";